var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-manager"},[(_vm.mode === 'new')?_c('div',[_c('p',{staticClass:"sign-in__message-below"},[_c('router-link',{attrs:{"to":"/get-started"}},[_vm._v("Add payment method.")])],1)]):_c('div',[_c('UpdateCard')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }